import {
	SupplierListInfo,
	SupplierListType,
} from "newui/features/Rfx/SupplierList/supplier-list-types";
import { cn } from "utils/helpers";

type SupplierListSuffixProps = {
	listType: SupplierListType;
};

export const SupplierListSuffix = ({ listType }: SupplierListSuffixProps) => {
	if (isNaN(listType)) {
		return null;
	}

	const info = SupplierListInfo[listType];

	return (
		<div
			className={cn(
				"rounded-lg px-2 py-1 text-xs !font-medium text-white",
				listType === SupplierListType.Panel
					? "bg-royal-blue text-white"
					: "bg-ring-blue-primary text-secondary-700"
			)}
		>
			{info.label}
		</div>
	);
};
